export default "__VITE_ASSET__dJeCUsw5__"